/**
 * List Schema of AuditoriaTransfolha
 * @author Simpli CLI generator
 */
import {
  Helper,
  Schema,
  FieldSet,
  FieldComponent,
  Component,
} from 'simpli-web-sdk'
import {AuditoriaTransfolha} from '@/model/resource/AuditoriaTransfolha'

/* TODO: review generated schema */
export class ListAuditoriaTransfolhaSchema extends Schema {
  readonly name = 'ListAuditoriaTransfolha'

  readonly fieldSet: FieldSet<AuditoriaTransfolha> = {
    idAuditoria: (): FieldComponent => ({
      is: Component.Render,
    }),
    lote: (): FieldComponent => ({
      is: Component.Render,
    }),
    json: (): FieldComponent => ({
      is: Component.Render,
    }),
    dataCriacao: (schema): FieldComponent => ({
      is: Component.Render,
      bind: {
        content: Helper.datetime(schema.model.dataCriacao),
      },
    }),
    reprocessar: (schema): FieldComponent => ({
      is: Component.Render,
      bind: {
        content: Helper.bool(schema.model.reprocessar),
      },
    }),
  }
}
